/* Polsk katalog for locale-completion-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('pl', {
  "common.rowUnavailable": "Nie uda?o si? wczyta? danych. Spr?buj ponownie.",
  "common.rowContextChanged": "Wybrana firma lub dokument uleg?y zmianie. Otw?rz je ponownie.",
  "common.bankStatementIncomplete": "Wyci?g bankowy nie zosta? w pe?ni wczytany. Spr?buj ponownie.",
  "common.journalProofUnavailable": "Nie uda?o si? zweryfikowa? danych ksi?gowych.",

  'pay.employeesAwaitingPayment': 'Pracownicy oczekujący na wypłatę: {{count}}',
  'pay.readyForPayment': 'Gotowe do wypłaty',
  'pay.readyForPaymentHelp': 'Zatwierdzone i zaksięgowane listy płac z wynagrodzeniem, którego wypłaty jeszcze nie zarejestrowano.',
  'pay.noRunsAwaitingPayment': 'Żadna lista płac nie oczekuje na wypłatę',
  'pay.noRunsAwaitingPaymentHint': 'Zatwierdzone listy płac są tu widoczne, dopóki wypłata nie zostanie zarejestrowana.',
  'pay.draftPayrollRuns': 'Szkice',
  'pay.noDraftPayrollRuns': 'Brak szkiców list płac.',
  'buy.ownerOutlay': 'Wydatek właściciela',
  'home.followup.assetPostingTitle': 'Amortyzacja',
  'home.followup.assetPostingAction': 'Zobacz odchylenie',
  'home.followup.assetPostingIssue': 'Automatyczna amortyzacja wymaga działania. Sprawdź plan aktywa lub skontaktuj się z pomocą techniczną. Plumme spróbuje ponownie po usunięciu odchylenia.',
  'ui.cancel': 'Anuluj',
  'ui.close': 'Zamknij',
  'ui.back': 'Wstecz',
  'ui.continue': 'Dalej',
  'ui.open': 'Otwórz',
  'app.close': 'Zamknij',
  'common.loadMore': 'Za?aduj wi?cej', 'common.loading': 'Wczytywanie...',
  'shell.collapse': 'Zwiń menu',
  'chat.cardFromFirm': 'Księgowy napisał',
  'chat.cardFromYou': 'Ty napisałeś',
  'chat.cardNone': 'Brak wiadomości',
  'chat.firm': 'Twój księgowy',
  'chat.helpTitle': 'Twój księgowy',
  'chat.help': 'Pisz bezpośrednio do swojego księgowego. Tę rozmowę widzisz tylko Ty jako właściciel lub administrator.',
  'chat.cardOpenUnread': 'Przeczytaj wiadomość',
  'chat.cardOpen': 'Wyślij wiadomość',
  'chat.modalTitle': 'Masz nieprzeczytaną wiadomość',
  'chat.modalOpen': 'Otwórz czat',
  'chat.modalBody': 'wysłał Ci wiadomość, której nie przeczytałeś.',
  'chat.client': 'Klient',
  'chat.subFirm': 'Rozmowa z klientem',
  'chat.subClient': 'Rozmowa z Twoim księgowym',
  'chat.emptyFirm': 'Brak wiadomości. Napisz tu do klienta — zobaczy ją w Plumme.',
  'chat.emptyClient': 'Brak wiadomości. Zapytaj swojego księgowego o to, co Cię nurtuje.',
  'chat.placeholder': 'Napisz wiadomość …',
  'chat.send': 'Wyślij',
  'rf.client.takeoverSaved': 'Data przejęcia została zapisana',
  'rf.client.takeover': 'Data przejęcia',
  'rf.client.takeoverHelp': 'Okresy i terminy przed tą datą nie są traktowane jako praca biura. Obowiązki samego klienta się nie zmieniają.',
  'rf.client.takeoverSave': 'Zapisz datę',
  'clo.cash.invalidAmount': 'Wpisz policzony stan gotówki.',
  'clo.cash.documentationRequired': 'Opisz dokumentację liczenia, zanim zatwierdzisz.',
  'clo.cash.saved': 'Inwentaryzacja gotówki została zapisana.',
  'clo.cash.saveError': 'Nie udało się zapisać inwentaryzacji gotówki.',
  'clo.cash.title': 'Monety i banknoty',
  'clo.cash.readySubtitle': 'Gotówka została policzona i zgadza się z kontem 1900.',
  'clo.cash.naSubtitle': 'Na koncie 1900 nie zarejestrowano stanu gotówki.',
  'clo.cash.todoSubtitle': 'Policz gotówkę na 31.12 i porównaj z kontem 1900.',
  'clo.cash.noStatus': 'Status gotówki nie został jeszcze obliczony.',
  'clo.cash.booked': 'Zaksięgowano na 1900',
  'clo.cash.counted': 'Policzono na 31.12',
  'clo.cash.difference': 'Różnica',
  'clo.cash.countedField': 'Policzony stan gotówki',
  'clo.cash.account': 'Konto kasowe',
  'clo.cash.documentation': 'Dokumentacja liczenia',
  'clo.cash.documentationPlaceholder': 'Na przykład: kasę policzył prezes zarządu 31.12. Arkusz inwentaryzacji zapisano w folderze dokumentów.',
  'clo.cash.noDifferenceHelp': 'Gdy policzony stan zgadza się z kontem 1900, inwentaryzacja jest zapisywana jako dokumentacja bez dodatkowego księgowania.',
  'clo.cash.surplusHelp': 'Różnica zwiększa konto 1900 i jest księgowana w pozostałe przychody.',
  'clo.cash.shortageHelp': 'Różnica zmniejsza konto 1900 i jest księgowana w pozostałe koszty.',
  'clo.cash.approve': 'Zatwierdź inwentaryzację',
  'clo.chart.suggestionsReady': 'Propozycje są gotowe do zatwierdzenia.',
  'clo.chart.noSuggestions': 'Nie znaleziono pewnych propozycji.',
  'clo.chart.pickBeforeApprove': 'Wybierz konto standardowe, zanim zatwierdzisz.',
  'clo.chart.saved': 'Zapisane powiązania kont: {{count}}',
  'clo.chart.saveError': 'Nie udało się zapisać powiązań kont.',
  'clo.chart.title': 'Plan kont',
  'clo.chart.missingSubtitle': 'Własne konta bez powiązania z kontem standardowym: {{count}}.',
  'clo.chart.readySubtitle': 'Plan kont jest gotowy do zamknięcia roku.',
  'clo.chart.allMapped': 'Wszystkie konta własne są powiązane z kontem standardowym.',
  'clo.chart.instructions': 'Wybierz, któremu kontu standardowemu odpowiada każde konto własne.',
  'clo.chart.aiSuggest': 'Znajdź propozycje z AI',
  'clo.chart.accountFallback': 'Konto {{code}}',
  'clo.chart.missingMapping': 'Brak powiązania standardowego',
  'clo.chart.equivalent': 'Odpowiadające konto standardowe',
  'clo.chart.reset': 'Wyczyść propozycje',
  'clo.chart.approve': 'Zatwierdź propozycje ({{count}})',
  'clo.share.title': 'Kapitał zakładowy',
  'clo.share.readySubtitle': 'Kapitał zakładowy jest zaksięgowany na koncie 2000.',
  'clo.share.missingSubtitle': 'Sprawdź lub zaksięguj kapitał zakładowy przed zakończeniem zamknięcia roku.',
  'clo.share.noStatus': 'Status kapitału zakładowego nie został jeszcze obliczony.',
  'clo.share.booked': 'Zaksięgowano na 2000',
  'clo.share.minimum': 'Minimum dla norweskiej AS',
  'clo.share.lossNote': 'Strat ani utraconego kapitału własnego zwykle nie wyksięgowuje się z konta 2000. Ocenia się je w ramach kapitału własnego, podziału wyniku i kontynuacji działalności. Ten punkt sprawdza tylko, czy zarejestrowany kapitał zakładowy jest zaksięgowany po stronie Ma konta 2000.',
  'clo.share.freePosting': 'Zaksięguj kapitał zakładowy',
  'sharedText.app.employeePortalVerifyTitle': 'Potwierdź swój adres e-mail',
  'sharedText.auth.remember': 'Zapamiętaj mnie',
  'sharedText.auth.noAccount': 'Nie masz konta?',
  'sharedText.auth.forgotCopy': 'Wpisz e-mail, którego używasz do logowania, a wyślemy Ci link do ustawienia nowego hasła.',
  'sharedText.acc.sentLinkTo': 'Wysłaliśmy link na adres',
  'sharedText.rep.export.year': 'Rok',
  'sharedText.bank.previewVoucher': 'Podgląd dokumentu',
  'sharedText.km.returnTrip': 'Tam i z powrotem',
  'sharedText.pay.paidOut': 'Wypłacono',
  'sharedText.inv.col.net': 'Netto',
  'sharedText.transaction.by': 'przez',
  'sharedText.buy.pickCategory': 'Konto/kategoria',
  'sharedText.vat.vat': 'VAT',
  'sharedText.sup.seeVoucher': 'Zobacz dokument',
  'sharedText.bwf.correctEntry': 'Skoryguj księgowanie',
  'sharedText.ap.approve': 'Zatwierdź',
  'sharedText.sale.pay.partialStatusRemaining': 'pozostało',
  'sharedText.helpTopics.ocrCorrection.title': 'Popraw odczyt',
  'sharedText.pay.note': 'Notatka',
  'sharedText.bank.openingBalance': 'Saldo początkowe',
  'sharedText.asset.closing': 'Saldo końcowe',
  'sharedText.sale.att.dropHere': 'Upuść dokument tutaj',
  'sharedText.voucher.pickAccount': 'Wybierz konto',
  'sharedText.adv.scn.plan.interest': 'Odsetki',
  'sharedText.sale.pay.fee': 'Opłata',
  'sharedText.ui.cancel': 'Anuluj',
  'sharedText.bwf.selectLine': 'Wybierz wiersz bankowy',
  'sharedText.bg.bankLines': 'Wiersze bankowe',
  'sharedText.home.ana.ring': 'Podział',
  'sharedText.pj.row.new': 'Nowy wiersz',
  'sharedText.bank.bankLine': 'Wiersz bankowy',
  'sharedText.helpTopics.openItem.title': 'Pozycja otwarta',
  'sharedText.clo.amount': 'Kwota',
  'sharedText.adv.status.more': 'Więcej opcji',
  'sharedText.inboxStatus.dropReceipts': 'Upuść dokumenty tutaj',
  'sharedText.bank.uploading': 'Przesyłanie …',
  'sharedText.set.showAll': 'Pokaż wszystko',
  'sharedText.bank.voucherReceivedOn': 'Dokument otrzymany',
  'sharedText.set.acc.lines': 'wiersze',
  'sharedText.nav.budget': 'Budżet',
  'sharedText.bud.actual': 'Wykonanie',
  'sharedText.ui.close': 'Zamknij',
  'sharedText.pay.signOut': 'Wyloguj',
  'sharedText.rf.group.firm': 'Księgowy',
  'sharedText.rf.create.title': 'Utwórz biuro rachunkowe',
  'sharedText.ui.open': 'Otwórz',
  'sharedText.buy.next': 'Dalej',
  'sharedText.adv.docs.hide': 'Ukryj',
  'sharedText.fe.decline': 'Odrzuć',
  'sharedText.common.yes': 'Tak',
  'sharedText.ap.review.checked': 'Sprawdzono',
  'sharedText.clo.pick': 'Wybierz',
  'sharedText.nav.taxReturn': 'Skattemelding',
  'sharedText.clo.financialYear': 'Rok obrotowy',
  'sharedText.helpTopics.residualValue.title': 'Wartość rezydualna',
  'sharedText.clo.inventoryReview.undecided': 'Wybierz ocenę',
  'sharedText.helpTopics.readyForUse.title': 'Gotowe do użytku',
  'sharedText.asset.work.residualValue': 'Oczekiwana wartość rezydualna',
  'sharedText.inv.credit.line': 'Wiersz',
  'sharedText.buy.paid': 'Zapłacono',
  'sharedText.km.from': 'Skąd',
  'sharedText.km.to': 'Dokąd',
  'sharedText.set.accountNo': 'Nr konta',
  'sharedText.sale.credit.previewReason': 'Przyczyna:',
  'sharedText.clo.description': 'Opis',
  'sharedText.prd.price': 'Cena',
  'sharedText.clo.sum': 'Suma',
  'sharedText.inv.kpi.sub.exVat': 'Bez VAT',
  'sharedText.set.page': 'Strona',
  'sharedText.sale.cust.org': 'Nr org.',
  'sharedText.trv.vehicle': 'Pojazd',
  'sharedText.ap.monthControl.finding.deviation': 'Możliwe odchylenie',
  'sharedText.vat.cancel': 'Anuluj',
  'sharedText.bank.review': 'Sprawdź',
  'sharedText.inbox.supplierInvoice': 'Faktura zakupu',
  'sharedText.bank.roundingHelp': 'Używaj tego tylko przy rzeczywistej niewielkiej różnicy z zaokrąglenia. Kwota jest księgowana bez VAT w korespondencji z',
  'sharedText.trv.reason': 'Uzasadnienie',
  'sharedText.set.acc.vatRegisteredPick': 'Wybierz odpowiedź',
  'sharedText.set.acc.vatRegisteredUnknown': 'Nie wiem',
  'sharedText.set.acc.vatRegisteredFrom': 'Zarejestrowany jako podatnik VAT od',
  'sharedText.vat.due': 'Termin',
  'sharedText.pay.advance': 'Zaliczka',
  'sharedText.pay.aga': 'AGA',
  'sharedText.inv.col.number': 'Nr',
  'sharedText.onb.createPersonal': 'Utwórz swoje finanse prywatne',
  'sharedText.onb.createPersonalHelp': 'To tworzy osobnego użytkownika finansów prywatnych, którego znajdziesz na Mojej stronie i w przełączniku użytkowników.',
  'sharedText.onb.noBankData': 'Połączenie z bankiem nie jest jeszcze aktywne. Możesz w dowolnym momencie przesłać wyciągi bankowe ręcznie.',
  'sharedText.po.youHaveStated': 'Podałeś, że',
  'sharedText.po.wealthStrongestOn': 'Twój majątek wypada najlepiej pod względem',
  'sharedText.po.withYourAssumptions': 'Przy wprowadzonych założeniach Twój majątek zmieni się o około',
  'sharedText.po.splitIsEven': 'Podział jest równy. Dzielicie',
  'sharedText.po.householdHasRegistered': 'Gospodarstwo domowe zarejestrowało',
  'sharedText.po.budgetTotal': 'Suma budżetu:',
  'sharedText.set.bank.typeTax': 'Potrącenie podatku',
  'sharedText.clo.no': 'Nie',
  'sharedText.po.showingScenario': 'Wyświetlany scenariusz:',
  'sharedText.po.desiredNetWealth': 'Docelowy majątek netto',
  'sharedText.po.lastsUntilYouAre': 'wystarczy, aż będziesz mieć',
  'sharedText.sd.transition.years': 'lat',
  'sharedText.po.lasts': 'wystarczy na',
  'sharedText.po.prioritise': 'Nadaj priorytet',
  'sharedText.adv.scn.loan.monthsUnit': 'mies.',
  'sharedText.po.doYouWantToDelete': 'Czy chcesz usunąć',
  'sharedText.po.householdSpends': 'Gospodarstwo domowe wydaje',
  'sharedText.po.iRecommend': 'Polecam',
  'sharedText.po.debtFree': 'Bez zadłużenia',
  'sharedText.po.interestPostedAs': 'Odsetki i raty tego kredytu są księgowane jako',
  'sharedText.helpTopics.buffer.title': 'Rezerwa płynności',
  'sharedText.clo.save': 'Zapisz',
  'sharedText.adv.profile.buffer': 'Pożądana rezerwa',
  'sharedText.home.legend.income': 'Przychody',
  'sharedText.set.bank.typeSavings': 'Oszczędności',
  'sharedText.pay.category': 'Kategoria',
  'sharedText.set.account': 'Konto',
  'sharedText.po.allAccounts': 'Wszystkie konta',
  'sharedText.adv.status.snooze7': 'Przypomnij mi za tydzień',
  'sharedText.po.yourHealthScoreIs': 'Twój wskaźnik kondycji wynosi',
  'sharedText.po.outOf100': 'na 100',
  'sharedText.po.taxAssistant': 'Asystent zeznania podatkowego',
  'sharedText.cust.prev': 'Poprzedni',
  'sharedText.bank.finishReview': 'Zakończ przegląd',
  'sharedText.po.checkBasis': 'Podstawa kontroli',
  'sharedText.clo.name': 'Nazwa',
  'sharedText.set.text': 'Tekst',
  'sharedText.sale.textLine.boldShort': 'B',
  'sharedText.sale.textLine.italicShort': 'I',
  'sharedText.sale.lines.useDivider': 'Użyj linii oddzielającej',
  'sharedText.sale.textLine.dividerHint': 'Pokaż linię pod tekstem w dokumencie.',
  'sharedText.nav.products': 'Produkty',
  'sharedText.sale.textLine.titleNewText': 'Nowy wiersz tekstu',
  'sharedText.prd.deleted': 'Usunięto',
  'sharedText.pay.edit': 'Edytuj',
  'sharedText.clo.delete': 'Usuń',
  'sharedText.set.loans.startDate': 'Data rozpoczęcia',
  'sharedText.helpTopics.unitCost.title': 'Koszt jednostkowy',
  'sharedText.pay.optional': 'Opcjonalne',
  'sharedText.registry.group': 'Grupa produktów',
  'sharedText.clo.add': 'Dodaj',
  'sharedText.ha.products.account': 'Konto przychodów',
  'sharedText.clo.accountNumber': 'Numer konta',
  'sharedText.clo.accountName': 'Nazwa konta',
  'sharedText.buy.supplierNew': 'Nowy dostawca',
  'sharedText.auth.createAccount': 'Utwórz konto',
  'sharedText.set.acc.equivalent': 'Odpowiada kontu',
  'sharedText.bwf.entry': 'Księgowanie',
  'sharedText.sale.att.upload': 'Prześlij załącznik',
  'sharedText.vat.settlement': 'Rozliczenie',
  'sharedText.ap.agent.invoice.selectRow': 'Wybierz fakturę',
  'sharedText.ap.workspace.treatmentAsset': 'Zarejestruj jako środek trwały',
  'sharedText.bank.receiptLinked': 'Powiązano z pozycją bankową',
  'sharedText.sd.documents.count': 'dok.',
  'sharedText.set.debit': 'Winien',
  'sharedText.set.bank.accounts': 'Rachunki bankowe',
  'sharedText.sd.deleteBusinessHelp': '„Usuń firmę” usuwa wybraną firmę po 30 dniach przez backend. To poważna operacja.',
  'sharedText.vat.rate': 'Stawka',
  'sharedText.inv.bulk.noEmail': 'brak e-maila',
  'sharedText.trv.privateRefundOf': 'Prywatny zwrot za',
  'sharedText.asset.group': 'Grupa',
  'sharedText.asset.opening': 'Stan początkowy',
  'sharedText.asset.movements': 'Ruchy',
  'sharedText.set.credit': 'Ma',
  'sharedText.voucher.backToVat': 'Wróć do MVA-melding',
  'sharedText.vat.vatCode': 'Kod VAT',
  'sharedText.bank.markVoucherLostTitle': 'Oznacz dokument jako zagubiony',
  'sharedText.bank.voucherLostReason': 'Wyjaśnienie',
  'pay.salaryLineDeleted': 'Pozycja wynagrodzenia została usunięta.',
  'pay.salaryLineNotFound': 'Pozycja wynagrodzenia już nie istnieje.',
  'pay.deleteSalaryLine': 'Usuń pozycję wynagrodzenia',
  'pay.deleteSalaryLineConfirm': 'Czy usunąć „{{name}}” z tego szkicu listy płac?',
  'pay.accountingVouchers': 'Dowody księgowe',
  'pay.payrollVoucher': 'Dowód płacowy',
  'pay.paymentVoucher': 'Dowód płatności',
  'pay.paymentVoucherInDifferentYear': 'Płatność została zaksięgowana w {{year}} r., dlatego jest widoczna w zestawieniu obrotów i sald za ten rok.',
  'pay.settleSalaryLiability': 'Rozliczenie należnych wynagrodzeń',
  'pay.settleEmployeeExpense': 'Rozliczenie wydatków pracownika',
  'pay.paymentFromBank': 'Wypłata z rachunku bankowego',
});
